import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import usePDPPhotos from 'data-hooks/usePDPPhotos/index';
import useModularPDPPhotos from 'data-hooks/useModularPDPPhotos';
import usePDPViewGalleryImageEvent from 'data-hooks/useEvents/usePDPViewGalleryImageEvent';
import usePDPCylindoViewer from 'data-hooks/usePDPCylindoViewer';
import usePdpSelectedCustomizerTab from 'components/consumer/PDP/state/pdpSelectedCustomizerTab/usePdpSelectedCustomizerTab';
import usePDPOptions from 'components/consumer/PDP/state/context/usePDPOptions';
import { FABRIC_PRODUCT_OPTION_ID, LEATHER_PRODUCT_OPTION_ID, orientationOptionIds } from 'commons/constants';
import useRemoveBrokenImageUrls from 'global-state/brokenImageUrls/useRemoveBrokenImageUrls';
import PDPDesktopHeroGalleryUI from './PDPDesktopHeroGalleryUI';
const PDPDesktopHeroGallery = t0 => {
  const $ = _c(75);
  const {
    isEditOrder: t1,
    mainPhotoLink,
    mode: t2,
    pdpIsModularBYOProduct,
    slug,
    productHeroImage: t3,
    productCylindoHeroImage: t4
  } = t0;
  const isEditOrder = t1 === undefined ? false : t1;
  const mode = t2 === undefined ? "pdp" : t2;
  const productHeroImage = t3 === undefined ? null : t3;
  const productCylindoHeroImage = t4 === undefined ? null : t4;
  const {
    loading,
    error,
    data,
    actions
  } = usePDPPhotos(null, slug);
  const pdpSelectedCustomizerTab = usePdpSelectedCustomizerTab();
  let modularPhotosData = useModularPDPPhotos(null, slug);
  if (!pdpIsModularBYOProduct) {
    modularPhotosData = null;
  }
  const {
    viewGalleryImageEvent
  } = usePDPViewGalleryImageEvent();
  const {
    data: t5
  } = usePDPOptions();
  const {
    selectedOptionsExtended
  } = t5 === undefined ? {} : t5;
  const t6 = mode === "pdp";
  let t7;
  if ($[0] !== t6) {
    t7 = {
      isPDPDesktop: true,
      deferCylindoFetch: t6
    };
    $[0] = t6;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  const {
    cylindoFeatures,
    isCylindoAvailable,
    cylindoConfigurationPhotos,
    isMechanicalOpen,
    toggleMechanicalOpen,
    isCylindoConfigurationPhotos,
    dimensionShotUrls,
    currentDimensionShot,
    selectedDimensionShotIndex,
    hasMultipleDimensionShots,
    shouldShowDimensionThumbnail,
    goToNextDimensionShot,
    goToPreviousDimensionShot
  } = usePDPCylindoViewer(t7);
  let t8;
  if ($[2] !== data || $[3] !== modularPhotosData?.data || $[4] !== pdpIsModularBYOProduct) {
    t8 = pdpIsModularBYOProduct ? modularPhotosData?.data ?? {} : data;
    $[2] = data;
    $[3] = modularPhotosData?.data;
    $[4] = pdpIsModularBYOProduct;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  const {
    campaign,
    configurationPhotos: nonCylindoConfigurationPhotos,
    dimensionalImage,
    enableCrops,
    introVideoIds,
    isConfigFlipped,
    isVideoSelected,
    productName,
    selectedPhoto,
    studioPhotos: allStudioPhotos
  } = t8;
  const configurationPhotos = useRemoveBrokenImageUrls(isCylindoConfigurationPhotos ? cylindoConfigurationPhotos : nonCylindoConfigurationPhotos);
  const studioPhotos = useRemoveBrokenImageUrls(allStudioPhotos);
  let t9;
  if ($[6] !== actions || $[7] !== modularPhotosData?.actions || $[8] !== pdpIsModularBYOProduct) {
    t9 = pdpIsModularBYOProduct ? modularPhotosData?.actions ?? {} : actions;
    $[6] = actions;
    $[7] = modularPhotosData?.actions;
    $[8] = pdpIsModularBYOProduct;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  const {
    setSelectedPhoto,
    setIsVideoSelected
  } = t9;
  let t10;
  bb0: {
    if (!productCylindoHeroImage?.src) {
      t10 = false;
      break bb0;
    }
    const norm = _temp;
    const selectedUpholstery = selectedOptionsExtended?.[FABRIC_PRODUCT_OPTION_ID]?.value || selectedOptionsExtended?.[LEATHER_PRODUCT_OPTION_ID]?.value || null;
    const selectedSku = selectedUpholstery?.sku != null ? String(selectedUpholstery.sku) : null;
    const defaultSku = productCylindoHeroImage.defaultUpholsterySku != null ? String(productCylindoHeroImage.defaultUpholsterySku) : null;
    const upholsteryMatches = selectedSku && defaultSku ? selectedSku === defaultSku : norm(selectedUpholstery?.value) === norm(productCylindoHeroImage.defaultUpholsteryValue);
    const selectedOrientationId = orientationOptionIds.find(id => selectedOptionsExtended?.[id]);
    const selectedOrientation = selectedOrientationId ? selectedOptionsExtended?.[selectedOrientationId]?.value?.value : null;
    const orientationMatches = norm(selectedOrientation) === norm(productCylindoHeroImage.defaultOrientation);
    t10 = !(upholsteryMatches && orientationMatches);
  }
  const isNonDefaultCylindoVariant = t10;
  let t11;
  bb1: {
    if (selectedPhoto?.type === "dimensional") {
      if (currentDimensionShot) {
        let t12;
        if ($[10] !== currentDimensionShot.dimensionCode || $[11] !== currentDimensionShot.src || $[12] !== selectedPhoto) {
          t12 = {
            ...selectedPhoto,
            src: currentDimensionShot.src,
            dimensionCode: currentDimensionShot.dimensionCode
          };
          $[10] = currentDimensionShot.dimensionCode;
          $[11] = currentDimensionShot.src;
          $[12] = selectedPhoto;
          $[13] = t12;
        } else {
          t12 = $[13];
        }
        t11 = t12;
        break bb1;
      }
      if (dimensionalImage?.src) {
        let t12;
        if ($[14] !== dimensionalImage.src || $[15] !== selectedPhoto) {
          t12 = {
            ...selectedPhoto,
            src: dimensionalImage.src
          };
          $[14] = dimensionalImage.src;
          $[15] = selectedPhoto;
          $[16] = t12;
        } else {
          t12 = $[16];
        }
        t11 = t12;
        break bb1;
      }
      t11 = selectedPhoto;
      break bb1;
    }
    if (isCylindoConfigurationPhotos && selectedPhoto?.type === "cylindo") {
      t11 = selectedPhoto;
      break bb1;
    }
    if (productCylindoHeroImage?.src && !isNonDefaultCylindoVariant && !isCylindoConfigurationPhotos && selectedPhoto?.type !== "studio") {
      let t12;
      if ($[17] !== productCylindoHeroImage.src) {
        t12 = {
          type: "cylindo",
          id: productCylindoHeroImage.src,
          src: productCylindoHeroImage.src
        };
        $[17] = productCylindoHeroImage.src;
        $[18] = t12;
      } else {
        t12 = $[18];
      }
      t11 = t12;
      break bb1;
    }
    if (isCylindoAvailable && !selectedPhoto) {
      if (isCylindoConfigurationPhotos) {
        t11 = cylindoConfigurationPhotos[0];
        break bb1;
      }
      let t12;
      if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = {
          type: "cylindo"
        };
        $[19] = t12;
      } else {
        t12 = $[19];
      }
      t11 = t12;
      break bb1;
    }
    const resolved = selectedPhoto || studioPhotos[0];
    if (resolved?.src || resolved?.type === "dimensional" || resolved?.type === "cylindo") {
      t11 = resolved;
      break bb1;
    }
    if (productHeroImage?.src) {
      let t12;
      if ($[20] !== productHeroImage.src) {
        t12 = {
          type: "studio",
          id: productHeroImage.src,
          src: productHeroImage.src
        };
        $[20] = productHeroImage.src;
        $[21] = t12;
      } else {
        t12 = $[21];
      }
      t11 = t12;
      break bb1;
    }
    t11 = resolved;
  }
  const selectedPhotoToShow = t11;
  let t12;
  if ($[22] !== currentDimensionShot || $[23] !== dimensionalImage || $[24] !== selectedPhoto?.type) {
    t12 = () => {
      if (currentDimensionShot) {
        return currentDimensionShot;
      }
      if (selectedPhoto?.type === "dimensional" && dimensionalImage?.src) {
        return {
          src: dimensionalImage.src,
          dimensionCode: "static",
          id: "static-dimensional"
        };
      }
      return {
        src: "",
        dimensionCode: "none",
        id: "no-dimensional-shot"
      };
    };
    $[22] = currentDimensionShot;
    $[23] = dimensionalImage;
    $[24] = selectedPhoto?.type;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  selectedPhoto?.type;
  let t13;
  if ($[26] !== t12) {
    t13 = t12();
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  const currentDimensionShotToShow = t13;
  const showCylindoSsrHero = !isNonDefaultCylindoVariant && !!productCylindoHeroImage?.src;
  const ssrHeroSrc = showCylindoSsrHero ? productCylindoHeroImage.src : productHeroImage?.src || null;
  if (loading && !ssrHeroSrc) {
    const t14 = pdpSelectedCustomizerTab === "decide-later";
    let t15;
    if ($[28] !== mode || $[29] !== t14) {
      t15 = <PDPDesktopHeroGalleryUI loading={true} mode={mode} showDecideLaterOverlay={t14} />;
      $[28] = mode;
      $[29] = t14;
      $[30] = t15;
    } else {
      t15 = $[30];
    }
    return t15;
  }
  if (!data) {
    if (ssrHeroSrc) {
      const t14 = showCylindoSsrHero ? "cylindo" : "studio";
      let t15;
      if ($[31] !== ssrHeroSrc || $[32] !== t14) {
        t15 = {
          type: t14,
          id: ssrHeroSrc,
          src: ssrHeroSrc
        };
        $[31] = ssrHeroSrc;
        $[32] = t14;
        $[33] = t15;
      } else {
        t15 = $[33];
      }
      const t16 = pdpSelectedCustomizerTab === "decide-later";
      let t17;
      if ($[34] !== isEditOrder || $[35] !== mode || $[36] !== pdpIsModularBYOProduct || $[37] !== t15 || $[38] !== t16) {
        t17 = <PDPDesktopHeroGalleryUI selectedPhoto={t15} loading={false} mode={mode} showDecideLaterOverlay={t16} pdpIsModularBYOProduct={pdpIsModularBYOProduct} isEditOrder={isEditOrder} />;
        $[34] = isEditOrder;
        $[35] = mode;
        $[36] = pdpIsModularBYOProduct;
        $[37] = t15;
        $[38] = t16;
        $[39] = t17;
      } else {
        t17 = $[39];
      }
      return t17;
    }
    return null;
  }
  if (error) {
    return "Something went wrong, please try again";
  }
  const t14 = pdpSelectedCustomizerTab === "decide-later";
  let t15;
  if ($[40] !== cylindoConfigurationPhotos || $[41] !== setSelectedPhoto) {
    t15 = t16 => {
      const {
        id: id_0,
        index,
        src,
        type
      } = t16;
      if (type === "cylindo") {
        setSelectedPhoto?.(cylindoConfigurationPhotos[index] ?? null);
        return;
      }
      setSelectedPhoto?.({
        id: id_0,
        index,
        src,
        type
      });
    };
    $[40] = cylindoConfigurationPhotos;
    $[41] = setSelectedPhoto;
    $[42] = t15;
  } else {
    t15 = $[42];
  }
  const t16 = !isCylindoAvailable;
  let t17;
  if ($[43] !== campaign || $[44] !== configurationPhotos || $[45] !== currentDimensionShotToShow || $[46] !== cylindoFeatures || $[47] !== dimensionShotUrls || $[48] !== dimensionalImage || $[49] !== enableCrops || $[50] !== goToNextDimensionShot || $[51] !== goToPreviousDimensionShot || $[52] !== hasMultipleDimensionShots || $[53] !== introVideoIds || $[54] !== isConfigFlipped || $[55] !== isCylindoAvailable || $[56] !== isCylindoConfigurationPhotos || $[57] !== isEditOrder || $[58] !== isMechanicalOpen || $[59] !== isVideoSelected || $[60] !== mainPhotoLink || $[61] !== mode || $[62] !== pdpIsModularBYOProduct || $[63] !== productName || $[64] !== selectedDimensionShotIndex || $[65] !== selectedPhotoToShow || $[66] !== setIsVideoSelected || $[67] !== shouldShowDimensionThumbnail || $[68] !== studioPhotos || $[69] !== t14 || $[70] !== t15 || $[71] !== t16 || $[72] !== toggleMechanicalOpen || $[73] !== viewGalleryImageEvent) {
    t17 = <PDPDesktopHeroGalleryUI configurationPhotos={configurationPhotos} isMechanicalOpen={isMechanicalOpen} toggleMechanicalOpen={toggleMechanicalOpen} selectedPhoto={selectedPhotoToShow} dimensionsImage={dimensionalImage} shouldShowDimensionThumbnail={shouldShowDimensionThumbnail} isEditOrder={isEditOrder} enableCrops={enableCrops} loading={false} showDecideLaterOverlay={t14} setSelectedPhoto={t15} dimensionShotUrls={dimensionShotUrls} currentDimensionShot={currentDimensionShotToShow} hasMultipleDimensionShots={hasMultipleDimensionShots} selectedDimensionShotIndex={selectedDimensionShotIndex} goToNextDimensionShot={goToNextDimensionShot} goToPreviousDimensionShot={goToPreviousDimensionShot} studioPhotos={studioPhotos} isConfigFlipped={isConfigFlipped} introVideoIds={introVideoIds} isVideoSelected={isVideoSelected} setIsVideoSelected={setIsVideoSelected} productName={productName} cylindoFeatures={cylindoFeatures} isCylindoAvailable={isCylindoAvailable} isCylindoConfigurationPhotos={isCylindoConfigurationPhotos} viewGalleryImageEvent={viewGalleryImageEvent} pdpIsModularBYOProduct={pdpIsModularBYOProduct} mode={mode} mainPhotoLink={mainPhotoLink} campaign={campaign} displayOnlyConfigImages={t16} />;
    $[43] = campaign;
    $[44] = configurationPhotos;
    $[45] = currentDimensionShotToShow;
    $[46] = cylindoFeatures;
    $[47] = dimensionShotUrls;
    $[48] = dimensionalImage;
    $[49] = enableCrops;
    $[50] = goToNextDimensionShot;
    $[51] = goToPreviousDimensionShot;
    $[52] = hasMultipleDimensionShots;
    $[53] = introVideoIds;
    $[54] = isConfigFlipped;
    $[55] = isCylindoAvailable;
    $[56] = isCylindoConfigurationPhotos;
    $[57] = isEditOrder;
    $[58] = isMechanicalOpen;
    $[59] = isVideoSelected;
    $[60] = mainPhotoLink;
    $[61] = mode;
    $[62] = pdpIsModularBYOProduct;
    $[63] = productName;
    $[64] = selectedDimensionShotIndex;
    $[65] = selectedPhotoToShow;
    $[66] = setIsVideoSelected;
    $[67] = shouldShowDimensionThumbnail;
    $[68] = studioPhotos;
    $[69] = t14;
    $[70] = t15;
    $[71] = t16;
    $[72] = toggleMechanicalOpen;
    $[73] = viewGalleryImageEvent;
    $[74] = t17;
  } else {
    t17 = $[74];
  }
  return t17;
};
PDPDesktopHeroGallery.propTypes = {
  isEditOrder: PropTypes.bool,
  pdpIsModularBYOProduct: PropTypes.bool,
  mainPhotoLink: PropTypes.string,
  mode: PropTypes.oneOf(['pdp', 'quickview']),
  slug: PropTypes.string,
  productHeroImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    alt: PropTypes.string
  }),
  productCylindoHeroImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    alt: PropTypes.string,
    // The default selection this frame represents, so the gallery can confirm the current
    // (URL/user) selection still matches before painting it as the SSR LCP (CON-8293).
    defaultUpholsteryValue: PropTypes.string,
    defaultUpholsterySku: PropTypes.string,
    defaultOrientation: PropTypes.string
  })
};
export default PDPDesktopHeroGallery;
function _temp(value) {
  return value == null ? null : String(value).trim().toLowerCase();
}